<template>
  <div style="display: inline-block;">
    <span @click="show()" :id="'epress'+order.id">
      <slot></slot>
    </span>
    <el-dialog top="0" v-if="dialogFormVisible" class="el-dialog-sm custom-width-dialog-900" :close-on-click-modal="false" :modal="!mobiletype" :visible.sync="dialogFormVisible" width="90%" @close="init()">
      <div :class="{mobile_upload_order:mobiletype}">
        <h3 class="text-center">发货信息</h3>
        <el-form :model="form" class="dialog-form">
          <ul class="error-messages" v-if="!isEmptyErrors">
            <li v-for="error in errors">{{error[0].message}}</li>
          </ul>
          <div style="display:flex;justify-content: space-between;max-height:63vh;">
            <div style="width:45%;max-height:63vh;">
              <ProductList ref="ProductList" @showChooseImage="showChooseImage" :numEditable="true" :groupOrderLine="groupOrderLine" :goods_info="goods_info" :order="order" :operation="'发货'" v-on:changeType="changeType"></ProductList>
            </div>
            <div style="width:45%">
              <ul class="error-messages" v-if="!isEmptyErrors">
                <li v-for="error in errors">{{error[0].message}}</li>
              </ul>
              <el-form-item>
              <el-row>
                <el-col :span="12">
                  <el-radio v-model="haveLogistics" :label="1" @change='hasLogistics()'>物流运输</el-radio>
                </el-col>
                <el-col :span="12">
                  <el-radio v-model="haveLogistics" :label="0" @change="noLogistics()">无需物流</el-radio>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item prop="business_order_no" v-if="haveLogistics == 1">
              <el-select style="width:100%;"v-model="form.business_order_no"
               class="input-width customheight_auto" placeholder="商家订单号">
                <el-option
                  v-for="item in business_order_no_arr"
                  :key="item"
                  :label="item"
                  :value="item"></el-option>
              </el-select>
            </el-form-item>
              <el-form-item prop="express" v-if="haveLogistics == 1">
                <el-select style="width:100%;"
                            v-model="form.express"
                            clearable
                            filterable
                            :filter-method="remotetransportSearch"
                            class="input-width customheight_auto"
                            @change="handleSelect"
                            placeholder="请输入快递公司">
                            <el-option
                              v-for="item in remoteTrasports"
                              :key="item.id"
                              :label="item.value"
                              :value="item.id"></el-option>
                          </el-select>
              </el-form-item>
              <el-form-item prop="AWB" v-if="haveLogistics == 1">
                <YueDanIpt model="AWB" :object="form" placeholder="物流单号" v-on:blur="blur"></YueDanIpt>
              </el-form-item>
              <el-row v-if="haveLogistics == 1">
                <el-col :span="24" style="font-size: 10px;margin-bottom: 10px;">
                  * 若是无跟踪物流,请输入数字“0”
                </el-col>
              </el-row>
              <el-form-item prop="tracking_url" v-if="haveLogistics == 1">
                <YueDanIpt model="tracking_url" :object="form" placeholder="物流跟踪网址" :readonly="readonly"></YueDanIpt>
              </el-form-item>
              <div>
                <el-button :loading="loading" style="margin:20px 0;" class="block" type="primary"  @click="submit()">确 定</el-button>
              </div>
            </div>
          </div>      
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '../../../../services/api.js'
import YueDanIpt from '../../../../components/YueDanIpt'
import ProductList from './ProductList'
let _ = require('lodash')
const MaxCharNumber = 100
export default {
  name: 'UploadExpressCode',
  props: ['order', 'mobiletype'],
  components: {
    YueDanIpt: YueDanIpt,
    ProductList: ProductList
  },
  computed: {
  },
  data () {
    return {
      remoteTrasports:[],
      goods_info: [
        {image: '', remark: '', id: new Date().getTime()}
      ],
      activeName:'',
      business_order_no_arr:[],
      uploadType: '2',
      dialogFormVisible: false,
      isEmptyErrors: true,
      expressList: null,
      errors: null,
      readonly: false,
      isSelect: false,
      loading: false,
      haveLogistics:1,
      groupOrderLine:[],
      form:{
          AWB: '',
          express: '',
          tracking_url: '',
          business_order_no:'',
      },
      rules: {
        express: [
          { required: true, message: '快递公司是必填项', trigger: 'change' }
        ],
        AWB: [
          { required: true, message: '物流单号是必填项', trigger: 'blur' },
          { min: 0, max: MaxCharNumber, message: '物流单号长度在 0 到 100 个字符', trigger: 'blur' }
        ],
        goods_list: [
          { required: true, message: '发货商品是必选项', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    // 显示选择图片
    showChooseImage(){
      this.$emit('showChooseImage', 'uploadexpress')
    },
    changeType (data) {
      this.uploadType = data
    },
    async show () {
      this.groupOrderLine=[]
      let oldexpress=localStorage.getItem('merchant_express_'+this.order.business_id)?localStorage.getItem('merchant_express_'+this.order.business_id):'';
      if(oldexpress){
          await this.remotetransportSearch('')
      }
      this.form.express = oldexpress
      _.each(this.order.goods_list.filter(i=>i.package_id == this.$store.state.curPackageId), item => {
          item.checked = false
          this.groupOrderLine.push(item)
      })

      this.business_order_no_arr=((this.groupOrderLine.length && this.groupOrderLine[0].business_order_no) || this.order.business_order_no).split('|')  
      if(this.business_order_no_arr.length==1)
        this.form.business_order_no=this.business_order_no_arr[0]
      this.dialogFormVisible = true
      this.$store.commit('updateOpenDialog', true)

    },
    init () {
      this.errors = null
      this.isEmptyErrors = true
      /*_.each(this.groupOrderLine, line => {
        line.checked = false
      })*/
      this.$store.commit('updateOpenDialog', false)
    },
    changeExpress (val) {
      console.log(val)
      _.each(this.expressList, item => {
        if (item.id == val && this.form.AWB != '0' && this.form.AWB) {
          this.readonly = false
          let str
          if (item.tracking_url.indexOf('{0}') > -1) {
            if (item.tracking_url) {
              str = item.tracking_url.substring(item.tracking_url.indexOf('{'), item.tracking_url.indexOf('}') + 1)
            }
            this.form.tracking_url = item.tracking_url.replace(str, this.form.AWB)
          } else {
            this.form.tracking_url = item.tracking_url
          }
        } else if (item.id == val && this.form.AWB == '0') {
          this.form.tracking_url = ''
          this.readonly = true
        }
      })
    },
    blur (data) {
      if (this.form.express && data && data != '0') {
        this.readonly = false
        _.each(this.expressList, item => {
          if (this.form.express == item.id) {
            let str
            if(this.form.AWB.indexOf('|')>-1){
              let ship_url=''
              this.form.AWB.split('|').forEach((a)=>{
                  if(item.tracking_url.indexOf('{0}') > -1) {
                    str = item.tracking_url.substring(item.tracking_url.indexOf('{'),item.tracking_url.indexOf('}')+1)
                    ship_url = item.tracking_url.replace(str,a.replace(/ /g,''))
                  }else if(item.tracking_url.indexOf('{-1}') > -1){
                    if(item.tracking_url){
                      str = item.tracking_url.substring(item.tracking_url.indexOf('{'),item.tracking_url.indexOf('}')+1)
                      ship_url = item.tracking_url.replace(str,a.replace(/ /g,''))
                    }
                  }else{
                    ship_url = item.tracking_url
                  }
                  this.form.tracking_url+=ship_url+"|"
                })
                this.form.tracking_url=this.form.tracking_url.substring(0,this.form.tracking_url.length-1)
            }
            else{
              if (item.tracking_url.indexOf('{0}') > -1) {
                if (item.tracking_url) {
                  str = item.tracking_url.substring(item.tracking_url.indexOf('{'), item.tracking_url.indexOf('}') + 1)
                  this.form.tracking_url = item.tracking_url.replace(str, this.form.AWB.replace(/ /g,''))
                }
              } else if (item.tracking_url.indexOf('{-1}') > -1) {
                if (item.tracking_url) {
                  str = item.tracking_url.substring(item.tracking_url.indexOf('{'), item.tracking_url.indexOf('}') + 1)
                  this.form.tracking_url = item.tracking_url.replace(str, this.form.AWB.replace(/ /g,''))
                }
              } else {
                this.form.tracking_url = item.tracking_url
              }
            }
          }
        })
      } else if (this.form.express && data && data == '0') {
        this.form.tracking_url = ''
        this.readonly = true
      }
    },
    hasLogistics () {
      this.rules = {
        express: [
          { required: true, message: '快递公司是必填项', trigger: 'change' }
        ],
        AWB: [
          { required: true, message: '物流单号是必填项', trigger: 'blur' },
          { min: 0, max: MaxCharNumber, message: '物流单号长度在 0 到 100 个字符', trigger: 'blur' }
        ],
        goods_list: [
          { required: true, message: '发货商品是必选项', trigger: 'blur' }
        ]
      }
    },
    noLogistics () {
      this.form.express = ''
      this.form.AWB = ''
      this.form.tracking_url = ''
    },
    async querySearch (queryString, cb) {
      console.log(queryString)
      let query = {
        keyword: queryString
      }
      let res = await api.getExpressList(this, query)
      if (res.body.status == 'ok') {
        if (res.body.result.length > 0) {
          this.form.express = res.body.result[0].id
          this.isSelect = false
          this.errors = null
          this.isEmptyErrors = true
          let arr = []
          let expressList = []
          _.each(res.body.result, item => {
            if (item.type == '1') {
              expressList.push(item)
              arr.push({value: item.name, id: item.id})
            }
          })
          this.expressList = expressList
          cb(arr)
        } else {
          cb([])
        }
      }
    },
    async remotetransportSearch(queryString,callback){
      this.remoteTrasports = []
      let query = {
          keyword: queryString
        }
        let res = await api.getExpressList(this, query)
        if (res.body.status == 'ok') {
          if (res.body.result.length > 0) {
            this.isSelect = false
            this.errors = null
            this.isEmptyErrors = true
            let expressList = []
            _.each(res.body.result, item => {
              if (item.type == '1') {
                expressList.push(item)
                this.remoteTrasports.push({value: item.name, id: item.id})
              }
            })
            this.expressList = expressList
          }
        }
        this.transportSelect = false
        this.errors = null
        this.isEmptyErrors = true
        if(callback)
            callback()
    },
    handleSelect (item) {
      if(!item)
        this.remoteTrasports=[];
      this.isSelect = true
      this.blur(this.form.AWB)
    },
    async submit () {
      this.isEmptyErrors = true
      if (this.haveLogistics == 1) {
        let reg = /[0-9a-zA-Z\-]*/
        //GoBolt转运公司物流订单没有数字，暂时去掉数字限制
        //let reg = /[0-9a-zA-Z\-]*[0-9]+/
        if (!reg.test(this.form.AWB) || this.form.AWB.length >= MaxCharNumber) {
          this.isEmptyErrors = false
            this.errors = {
              business_name: [
                {message: '请输入正确的物流订单号,必须有字母或者数字,不超过100个字符'}
              ]
            }
            return
        }
        if (!this.form.express) {
          this.isEmptyErrors = false
          this.errors = {
            business_name: [
              {message: '请输入正确的快递公司,并在下拉框中选择该快递公司'}
            ]
          }
          return
        }
      }

      this.form.goods_list = []
      _.each(this.groupOrderLine, line => {
        if (line.checked) {
          this.form.goods_list.push({
            id: line.id,
            num: line.selectNum
          })
        }
      })
      if (this.form.goods_list.length==0 && this.order.type == '0') {
        this.isEmptyErrors = false
        this.errors = {
          business_name: [
            {message: '请选择您要上传的发货商品'}
          ]
        }
        return
      }
           
      if (this.order.type == '2') {
        _.each(this.goods_info, item => {
          if (!item.remark) {
            this.isEmptyErrors = false
            this.errors = {
              business_name: [
                {message: '请填写已发货商品名称和信息'}
              ]
            }
            return false
          } else {
            this.isEmptyErrors = true
            this.errors = {}
          }
        })
      }
      if (!this.isEmptyErrors) {
        return
      }
        let data = {}
        if (this.order.type == '0') {
          data = {
            order_id: this.order.id,
            express_id: this.form.express,
            AWB: this.form.AWB,
            business_order_no: this.form.business_order_no,
            goods_list: this.form.goods_list,
            update_time: this.order.update_time,
            ship_url: this.form.tracking_url,
            need_transport: this.haveLogistics,
            update_shipping_type: 'AWB'
          }
        }
        if (this.order.type == '2') {
          let goods_info = []
          _.each(this.goods_info, item => {
            goods_info.push({image: item.image, remark: item.remark})
          })
          data = {
            shipping_status: this.uploadType,
            order_id: this.order.id,
            express_id: this.form.express,
            AWB: this.form.AWB,
            business_order_no: this.form.business_order_no,
            goods_info: goods_info,
            update_time: this.order.update_time,
            ship_url: this.form.tracking_url,
            need_transport: this.haveLogistics,
            update_shipping_type: 'AWB'
          }
        }
        
        const submitHandler=async ()=>{
          let res
          if (this.order.type == '0') {
            res = await api.post(this, {
              path: 'order.php',
              api: 'upload_shipping_info_v2',
              data: data,
              loading: 'loading'
            })
          }
          if (this.order.type == '2') {
            res = await api.post(this, {
              path: 'order.php',
              api: 'upload_shipping_info_mp',
              data: data,
              loading: 'loading'
            })
          }

          res = res.body
          if (res.status == 'ok') {
            localStorage.setItem('merchant_express_'+this.order.business_id, this.form.express)
            this.dialogFormVisible = false
            Object.assign(this.order, res.result)

            this.order.order_list = res.result.order_list
            _.each(this.order.goods_list, good => {
              if (good.status == 3 || good.status == 7) {
                good.package_id = good.cancel_time
              }
            })
            this.order.groupOrderLines = _.groupBy(this.order.goods_list, 'package_id')
            this.order.update_time = res.result.update_time
            let data = {
              status: null,
              operationType: '上传商家物流成功',
              operation: '上传'
            }
            this.$emit('complete', data)
          }
          else if(res.result == 'already_updated'){
              this.$msgbox.alert('订单数据已更新，点击确定会自动更新数据', '数据更新', {
                confirmButtonText: '确定',
                callback: action => {
                  this.dialogFormVisible = false
                  Object.assign(this.order, res.description)
                  /*_.each(this.order.goods_list, good => {
                    if (good.status == 3 || good.status == 7) {
                      good.package_id = good.cancel_time
                    }
                  })*/
                  this.order.groupOrderLines = _.groupBy(this.order.goods_list, 'package_id')
                  this.order.update_time = res.description.update_time
                }
              })
            }
        }
        
        if(this.form.AWB=='0')
            submitHandler()
          else{
            let checkres
            checkres = await api.post(this, {
                path: 'order.php',
                api: 'check_merchant_store_number_exist',
                data: {order_id:this.order.id,merchant_id:this.order.business_id,merchant_store_number:this.form.AWB},
                loading: 'loading'
            })
            if(checkres.body.result.length){
              this.$confirm(`物流单号已被任务${checkres.body.result.join(',')}使用过，确认继续吗?`, '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
              }).then(() => {
                submitHandler()
              }).catch(() => {
                          
              });
            }
            else
              submitHandler()
          }
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .dialog-form {
    padding-bottom: 20px;
  }
  .tip {
    font-size: 12px;
    color: #888888;
    line-height: 16px;
  }
  .select-address {
    padding-bottom: 7px;
    border-bottom: 1px solid #CDCDCD;
    margin-bottom: 10px;
    margin-top: 20px;
    .tip {
      font-size: 16px;
    }
  }
.mobile_upload_order {
    padding: 0 10px !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/orders/list/single/UploadExpressDialog.vue